if (typeof document !== 'undefined' && process.env.NODE_ENV !== 'test' && !document.head.querySelector("style[data-wp-hash='a012fe845a']")) {
	const style = document.createElement("style");
	style.setAttribute("data-wp-hash", "a012fe845a");
	style.appendChild(document.createTextNode(".boot-save-button{width:100%}"));
	document.head.appendChild(style);
}
